














import { Component, Vue } from 'vue-property-decorator';
import { tokenService } from '../../services/TokenService';
import { localeService } from '../../services/LocaleService';

@Component({})
export default class LanguageSwitch extends Vue {
  changeLang(lang: string) {
    const isAuth = !!tokenService.getToken();

    this.$root.$i18n.locale = lang;

    if (isAuth) {
      localeService.setLocale(lang);
    } else {
      localStorage.setItem('locale', lang);
    }
  }
}
